var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._m(0),_c('PostForm',{attrs:{"payload":_vm.payload,"submit-text":'작성하기'},on:{"update:payload":_vm.updatePayload,"submit":_vm.processWrite,"cancel":_vm.moveToList}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subtitle"},[_c('h1',[_vm._v("자유게시판 글쓰기")])])
}]

export { render, staticRenderFns }